import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_PolteqButton = _resolveComponent("PolteqButton")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_card_text, { style: {"text-align":"center"} }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, {
        style: {"margin-bottom":"4px"},
        variant: "elevated",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.NavigationHelper.openForm(_ctx.router, _ctx.Forms.PROFILE)))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.i18n.t('buttons.profile')), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_card, {
        style: {"margin-bottom":"4px"},
        variant: "elevated",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.NavigationHelper.openForm(_ctx.router, _ctx.Forms.SERVICES)))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.i18n.t('buttons.services')) + " (" + _toDisplayString(_ctx.userStore.services.length) + ")", 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_dialog, { "max-width": "500" }, {
        activator: _withCtx(({ props: activatorProps }) => [
          (_ctx.hasWordpressAccess(_ctx.userStore.services))
            ? (_openBlock(), _createBlock(_component_v_card, _mergeProps({
                key: 0,
                style: {"margin-bottom":"4px"},
                variant: "elevated"
              }, activatorProps, {
                onClick: _cache[2] || (_cache[2] = ($event: any) => {
            _ctx.requestKey = true;
            _ctx.getApiKey();
          })
              }), {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_text, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.i18n.t('buttons.getkey')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 2
              }, 1040))
            : _createCommentVNode("", true)
        ]),
        default: _withCtx(({ isActive }) => [
          _createVNode(_component_v_card, {
            title: _ctx.i18n.t('texts.notimplemented')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_actions, { style: {"text-align":"end"} }, {
                default: _withCtx(() => [
                  _createVNode(_component_PolteqButton, {
                    "button-id": "closeButton",
                    icon: "mdi-close",
                    "button-text": _ctx.i18n.t('buttons.close'),
                    onClick: ($event: any) => (isActive.value = false)
                  }, null, 8, ["button-text", "onClick"])
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1032, ["title"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}